import 'firebase/compat/auth';

import firebase from 'firebase/compat/app';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyB3qiMEKhytRrUOgFM0f9vtU8y0kWWS6uA',
  authDomain: 'app-modulate.firebaseapp.com',
  projectId: 'app-modulate',
  storageBucket: 'app-modulate.firebasestorage.app',
  messagingSenderId: '854529390273',
  appId: '1:854529390273:web:3e1cb42c22952d4e938640',
  measurementId: 'G-3YVTBFM3Y0',
};

// Initialize Firebase
const app = firebase.initializeApp(firebaseConfig);
const auth = firebase.auth(app);

export const emailAuthCredential = (user, password) => {
  const credential = firebase.auth.EmailAuthProvider.credential(user.email, password);
  return credential;
};

export { app, auth };
